import React from "react";
import { Link} from "react-router-dom";
import logo from "../../assets/image/logo1.webp";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";

export default function Information() {
    return (
       
            <div className="logo_lien">
                <Link to="/#accueil" className="">
                    <img src={logo} alt="logo du site" className="logofooter" />
                </Link>
                <div className="containeresaus">
                    <a
                        href="https://www.facebook.com/100064771655879"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaFacebookSquare className="lienreseau face" />
                    </a>
                    <a
                        href="https://www.instagram.com/mamdjuicuisinedecor?igsh=MXdyaWhpNHI5anU3dQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaInstagramSquare className="lienreseau insta" />
                    </a>
                </div>
            </div>    
       
    );
}
